import Modal from 'react-bootstrap/Modal'
import {KTSVG} from '../../helpers'
import {useIntl} from 'react-intl'

function PreviewModal({
  setShow,
  show,
  topAdCurrent,
  topAd,
  firmaLogoCurrent,
  firmaLogo,
  bottomAdCurrent,
  bottomAd,
  registeredUser,
  userRegister,
  voucher,
  mernis,
  sms,
}: any) {
  // Dil
  const intl = useIntl()
  const t = (id: any, values = {}) => intl.formatMessage({id}, values)
  return (
    <>
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            <div>{t('preview')}</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='page'>
            <div className='page-wrapper justify-content-center'>
              <div className='page-body'>
                <div className='container-xl'>
                  <div className='row d-flex flex-column justify-content-center align-items-center'>
                    {/* HEADER */}
                    {/* topAd */}
                    {topAd.length > 0 || topAdCurrent ? (
                      <div className='col-12 mb-3' style={{maxWidth: '450px'}}>
                        <div className='card shadow' style={{overflow: 'hidden'}}>
                          <div className='card-body text-center p-0'>
                            <img
                              src={
                                topAd.length > 0
                                  ? URL.createObjectURL(topAd[0].file)
                                  : 'data:image/jpg;base64,' + topAdCurrent
                              }
                              width='auto'
                              height='auto'
                              alt=''
                            />
                          </div>
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                    <div className='col-12' style={{maxWidth: '450px'}}>
                      <div className='card shadow py-4'>
                        <div className='card-header row d-flex justify-content-center'>
                          {firmaLogo.length > 0 || firmaLogoCurrent ? (
                            <div
                              style={{
                                backgroundImage:
                                  firmaLogo.length > 0 && firmaLogo[0].file
                                    ? `url(${URL.createObjectURL(firmaLogo[0].file)})`
                                    : `url(data:image/jpg;base64,${firmaLogoCurrent})`,
                                backgroundSize: 'contain', // Ensures the image fits the div
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center', // Centers the image
                              }}
                              className='h-100px'
                            ></div>
                          ) : (
                            ''
                          )}
                          <div className='d-flex my-4 col-12 justify-content-center gap-3'>
                            <div>
                              <select
                                className='form-select border fs-6 fw-normal'
                                id='changeLanguage'
                                style={{width: '110px'}}
                              >
                                <option value='tr'>Türkçe</option>
                                <option value='en'>English</option>
                                <option value='ru'>Русский</option>
                              </select>
                            </div>
                            <div
                              className='border rounded d-flex align-items-center justify-content-center px-4'
                              id='changeTheme'
                            >
                              <KTSVG
                                path='/media/icons/tablerio/moon.svg'
                                className='svg-icon-2 text-dark'
                              />
                            </div>
                          </div>
                        </div>
                        {/* BODY */}
                        <div className='card-body row'>
                          {/* ITEM */}
                          {mernis === true && (
                            <div className='col-12 d-flex'>
                              <div className='col-2'>
                                <KTSVG
                                  path='/media/icons/tablerio/user-circle.svg'
                                  className='svg-icon-1 text-danger'
                                />
                              </div>
                              <div className='col-10'>
                                <div className='row'>
                                  <div className='col-12 d-flex justify-content-between fs-5 fw-bold'>
                                    <div>Misafir Girişi</div>
                                    <KTSVG
                                      path='/media/icons/tablerio/chevron-right.svg'
                                      className='svg-icon-1 text-dark'
                                    />
                                  </div>
                                  <div className='col-12 separator my-5 border-gray-300'></div>
                                </div>
                              </div>
                            </div>
                          )}
                          {/* ITEM */}
                          {registeredUser === true && (
                            <div className='col-12 d-flex'>
                              <div className='col-2'>
                                <KTSVG
                                  path='/media/icons/tablerio/user-check.svg'
                                  className='svg-icon-1 text-danger'
                                />
                              </div>
                              <div className='col-10'>
                                <div className='row'>
                                  <div className='col-12 d-flex justify-content-between fs-5 fw-bold'>
                                    <div>Kayıtlı Kullanıcı Girişi</div>
                                    <KTSVG
                                      path='/media/icons/tablerio/chevron-right.svg'
                                      className='svg-icon-1 text-dark'
                                    />
                                  </div>
                                  <div className='col-12 separator my-5 border-gray-300'></div>
                                </div>
                              </div>
                            </div>
                          )}
                          {/* ITEM */}
                          {userRegister === true && (
                            <div className='col-12 d-flex'>
                              <div className='col-2'>
                                <KTSVG
                                  path='/media/icons/tablerio/user-plus.svg'
                                  className='svg-icon-1 text-danger'
                                />
                              </div>
                              <div className='col-10'>
                                <div className='row'>
                                  <div className='col-12 d-flex justify-content-between fs-5 fw-bold'>
                                    <div>Kayıt Ol</div>
                                    <KTSVG
                                      path='/media/icons/tablerio/chevron-right.svg'
                                      className='svg-icon-1 text-dark'
                                    />
                                  </div>
                                  <div className='col-12 separator my-5 border-gray-300'></div>
                                </div>
                              </div>
                            </div>
                          )}
                          {/* ITEM */}
                          {sms === true && (
                            <div className='col-12 d-flex'>
                              <div className='col-2'>
                                <KTSVG
                                  path='/media/icons/tablerio/device-mobile-message.svg'
                                  className='svg-icon-1 text-danger'
                                />
                              </div>
                              <div className='col-10'>
                                <div className='row'>
                                  <div className='col-12 d-flex justify-content-between fs-5 fw-bold'>
                                    <div>Sms İle Giriş</div>
                                    <KTSVG
                                      path='/media/icons/tablerio/chevron-right.svg'
                                      className='svg-icon-1 text-dark'
                                    />
                                  </div>
                                  <div className='col-12 separator my-5 border-gray-300'></div>
                                </div>
                              </div>
                            </div>
                          )}
                          {/* ITEM */}
                          {voucher === true && (
                            <div className='col-12 d-flex'>
                              <div className='col-2'>
                                <KTSVG
                                  path='/media/icons/tablerio/ticket.svg'
                                  className='svg-icon-1 text-danger'
                                />
                              </div>
                              <div className='col-10'>
                                <div className='row'>
                                  <div className='col-12 d-flex justify-content-between fs-5 fw-bold'>
                                    <div>Kupon İle Giriş</div>
                                    <KTSVG
                                      path='/media/icons/tablerio/chevron-right.svg'
                                      className='svg-icon-1 text-dark'
                                    />
                                  </div>
                                  <div className='col-12 separator my-5 border-gray-300'></div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                        {/* FOOTER */}
                        <div className='card-footer bg-secondary bg-opacity-25'>
                          <div className='form-check cursor-default'>
                            <input
                              className='form-check-input border-danger pe-none bg-danger'
                              defaultChecked={true}
                              type='checkbox'
                              id='checkboxContractAndTerms'
                            />
                            <div>
                              İnternet hizmetini kullanmak için{' '}
                              <span className='text-danger cursor-pointer'>
                                Sözleşme şart ve koşulları
                              </span>{' '}
                              kabul ediyorum.
                              <p className='fs-8 my-1'>
                                Kişisel verileriniz 5651 ve 6698 sayılı kanunlar gereğince kayıt
                                altına alınarak işlenmektedir.
                              </p>
                            </div>
                          </div>
                          <div className='separator my-5 border-gray-300'></div>
                          <div className='d-flex my-2 row text-gray-700'>
                            <div className='d-flex col-6 text-center row'>
                              <div>Teknik Destek</div>
                              <div className='fw-light'>Wisnet Teknoloji A.Ş</div>
                              <div className='fw-light'>(850) 304-2131</div>
                            </div>
                            <div className='col-6 text-center'>
                              <img src='/media/logos/netway.png' alt='' />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* bottomAd */}
                    {bottomAd.length > 0 || bottomAdCurrent ? (
                      <div className='col-12 my-3' style={{maxWidth: '450px'}}>
                        <div className='card shadow' style={{overflow: 'hidden'}}>
                          <div className='card-body text-center p-0'>
                            <img
                              src={
                                bottomAd.length > 0
                                  ? URL.createObjectURL(bottomAd[0].file)
                                  : 'data:image/jpg;base64,' + bottomAdCurrent
                              }
                              width='auto'
                              height='auto'
                              alt=''
                            />
                          </div>
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default PreviewModal
